import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const blogs = [
  {
    id: 1,
    title: "Global Capability Center (GCCs): The Strategic Engines Powering Global Business Transformation",
    category: "Global Capability Center",
    image: "https://techprojects.com/static/media/1768981753549-613088248.png",
    date: "July 8, 2026",
    author: "TechProjects",
    excerpt:
      "A Global Capability Center (GCC) is a dedicated offshore or nearshore center owned by a multinational company that delivers critical business functions such as software development, cybersecurity, finance, analytics, and research.",
    slug: "global-capability-center",
  },
  {
    id: 2,
    title: "Oracle ERP Implementation in NJ: The 2026 Complete Guide",
    category: "Oracle ERP",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800",
    date: "July 16, 2026",
    author: "TechProjects",
    excerpt:
      "If you're a New Jersey business considering an Oracle ERP implementation in 2026, you're facing one of the most consequential technology decisions your company will make. Get it right, and you gain real-time visibility across finance, supply chain, and HR. Get it wrong, and you're looking at cost overruns, delayed go-lives, and years of workarounds.",
    slug: "oracle-erp-consulting-new-jersey-guide",
  },
  {
    id: 3,
    title: "Best IT Consulting Company in Hyderabad",
    category: "IT Consulting",
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800",
    date: "July 22, 2026",
    author: "TechProjects",
    excerpt:
      "Looking for the best IT consulting company in Hyderabad? Learn how to choose the right technology partner and discover how Tech projects deliver cloud, AI, cybersecurity, and digital transformation solutions.",
    slug: "best-it-consulting-company-hyderabad",
    },
  {
    id: 4,
    title: "Digital Transformation Companies in Hyderabad",
    category: "Digital Transformation",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800",
    date: "July 29, 2026",
    author: "TechProjects",
    excerpt:
      "Digital transformation is reshaping how businesses operate, compete, and deliver value to customers. Organizations across industries are investing in cloud computing, artificial intelligence (AI), automation, data analytics, and enterprise applications to improve efficiency and accelerate growth.",
    slug: "digital-transformation-companies-in-hyderabad",
  },
  {
    id: 5,
    title: "Global Capability Centers Hyderabad",
    category: "Global Capability Centers",
    image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800",
    date: " August 02, 2026",
    author: "TechProjects",
    excerpt:
      "As U.S. businesses accelerate digital transformation and global expansion, Global Capability Centers in Hyderabad have become a strategic investment for driving innovation, operational excellence, and business growth.",
    slug: "expanding-gcc-operations-in-hyderabad",
  },
  {
    id: 6,
    title: "Cybersecurity compliances companies in hyderabad ",
    category: "Cybersecurity",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800",
    date: "August 12, 2026",
    author: "TechProjects",
    excerpt:
      "Cybersecurity compliance has become a strategic business priority in 2026. Organizations are no longer concerned only about preventing cyberattacks; they must also demonstrate that their security controls, data governance, risk management and incident-response processes meet evolving regulatory and industry requirements.",
    slug: "cybersecurity-compliances-companies-in-hyderabad",
  },
  // {
  //   id: 7,
  //   title: "Future of Cyber Security",
  //   category: "Security",
  //   image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800",
  //   date: "June 8, 2026",
  //   author: "TechProjects",
  //   excerpt:
  //     "Explore the latest cyber threats and learn modern strategies for protecting enterprise systems.",
  //   slug: "future-cyber-security",
  // },
];

function BlogGridPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const filteredBlogs = blogs.filter(
    (blog) =>
      blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.excerpt.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleReadMore = (slug) => {
    navigate(`/blog/${slug}`);
  };

  return (
    <>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">
            TechProjects Blog
          </h1>
          <p className="text-xl md:text-2xl font-light text-blue-100">
            Latest insights on Software Development, Artificial Intelligence,
            Cloud Computing, DevOps, and Digital Transformation
          </p>
        </div>
      </section>

      {/* Search Section */}
      <section className="py-8 bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto">
            <div className="relative">
              <input
                type="text"
                className="w-full px-6 py-3 border-2 border-blue-600 rounded-full focus:outline-none focus:border-blue-700 text-gray-900"
                placeholder="Search articles by title, category, or keyword..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <p className="text-center text-gray-600 mt-4">
              {filteredBlogs.length} article{filteredBlogs.length !== 1 ? "s" : ""} found
            </p>
          </div>
        </div>
      </section>

      {/* Blog Grid Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredBlogs.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredBlogs.map((blog) => (
                <div
                  key={blog.id}
                  className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                  onClick={() => handleReadMore(blog.slug)}
                >
                  {/* Image Container */}
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>

                  {/* Content */}
                  <div className="p-6 flex flex-col h-full">
                    {/* Category Badge */}
                    <span className="inline-block w-fit mb-3 bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide">
                      {blog.category}
                    </span>

                    {/* Title */}
                    <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2">
                      {blog.title}
                    </h3>

                    {/* Excerpt */}
                    <p className="text-gray-600 text-sm flex-grow mb-4 line-clamp-3">
                      {blog.excerpt}
                    </p>

                    {/* Metadata */}
                    <div className="flex justify-between items-center text-xs text-gray-500 mb-4 pb-4 border-b border-gray-200">
                      <span>{blog.author}</span>
                      <span>{blog.date}</span>
                    </div>

                    {/* Button */}
                    <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-full transition-colors duration-200">
                      Read More →
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-lg text-gray-600">
                No articles found matching your search. Try different keywords.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Stay Updated
          </h2>
          <p className="text-lg text-blue-100 mb-8">
            Subscribe to receive the latest technology articles directly in your
            inbox.
          </p>

          <div className="max-w-md mx-auto">
            <div className="flex gap-2">
              <input
                type="email"
                className="flex-1 px-4 py-3 rounded-full text-gray-900 focus:outline-none"
                placeholder="Enter your email"
              />
              <button className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold px-6 py-3 rounded-full transition-colors duration-200">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BlogGridPage;
